export default "__VITE_ASSET__C2lPLHfC__"